<template>
  <div class="mi-site mi-site--page">
    <a class="mi-skip" href="#main">Skip to content</a>
    <MarketingHeader />

    <main id="main" class="mi-doc">
      <header class="mi-shell mi-doc-hero">
        <p class="mi-kicker">
          <span class="mi-kicker-dot" aria-hidden="true"></span>
          Legal
        </p>
        <h1>Privacy policy</h1>
        <p class="mi-lede mi-lede--left">Effective August 19, 2026. MLS Ingest.</p>
      </header>

      <article class="mi-article">
        <div class="mi-article-inner">
          <p>
            This policy describes how MLS Ingest (“we,” “us”)
            handles information when you use mlsingest.com, our operator tools,
            and related services. MLS Ingest is a Brokurz company.
          </p>

          <h2>What we collect</h2>
          <p>
            <strong>Contact and sales.</strong> Name, work email, phone, brokerage,
            role, the board you care about, and whatever you write in the form
            or send to {{ email }}.
          </p>
          <p>
            <strong>Operator accounts.</strong> Email and authentication data for
            people invited to run the ingest admin.
          </p>
          <p>
            <strong>MLS data.</strong> Listing, member, office, and media records
            we are licensed to replicate from MLS boards and vendors (including
            MLS Grid, Trestle, and Bridge Interactive). That data belongs to the
            MLS and participating brokers. We process it to provide the service,
            not to sell a consumer database.
          </p>
          <p>
            <strong>Service logs.</strong> Technical logs (time, path, errors,
            sync status) used to operate and secure the network.
          </p>

          <h2>How we use it</h2>
          <p>
            To reply to sales and licensing requests, run replication, show
            listings on authorized Brokurz websites, keep status accurate, meet
            MLS vendor rules, and protect the service.
          </p>

          <h2>Sharing</h2>
          <p>
            We share information with Brokurz as the parent company that hosts
            brokerage sites; with MLS vendors and boards as required by your
            data license; and with infrastructure providers (hosting, email,
            database) that process data on our instructions. We do not sell
            personal information.
          </p>

          <h2>Retention</h2>
          <p>
            Sales inquiries are kept as long as needed to respond and for a
            reasonable follow-up period. Operator accounts last until revoked.
            MLS records follow the license and purge rules of the source MLS.
          </p>

          <h2>Security</h2>
          <p>
            Access to operator tools is authenticated. Credentials for MLS
            vendors are stored as secrets, not in public pages. No method of
            transmission or storage is perfectly secure.
          </p>

          <h2>Your choices</h2>
          <p>
            To access, correct, or delete personal information we hold about
            you (for example a sales inquiry), email {{ email }}. MLS listing
            content is controlled by the listing broker and the MLS, not by a
            consumer “delete my house” request to us.
          </p>

          <h2>Children</h2>
          <p>The service is for real estate professionals. It is not directed at children.</p>

          <h2>Contact</h2>
          <p>
            MLS Ingest<br />
            <a :href="'mailto:' + email">{{ email }}</a>
          </p>
        </div>
      </article>
    </main>

    <MarketingFooter />
  </div>
</template>

<script>
import MarketingHeader from './MarketingHeader'
import MarketingFooter from './MarketingFooter'
import { CONTACT_EMAIL } from '../lib/brand'
import '../assets/marketing.css'

export default {
  name: 'PrivacyPage',
  components: { MarketingHeader, MarketingFooter },
  data() {
    return { email: CONTACT_EMAIL }
  },
}
</script>
